// extracted by mini-css-extract-plugin
module.exports = {"tabIcon":"RankingTabs_tabIcon__QgW7J"};